import React from 'react';
import {observable, observe} from 'mobx';
import {getServerTexts} from '../texts';
import ModalMessage from './Messages';
import {registerModalCallbacks} from '../actions/MessageActions';
import {setHasModalChild} from '../../../_shared/GWTBridge/invoke/netForm';
import {sendMonitor} from '../../../utils/monitoring';

const regModalCallbacks = instance => {
    //listen to modalOpen to addEventListener or  removeEventListener
    const ref = instance.get();
    try {
        registerModalCallbacks(ref.showMessage, ref.modalOpen);
        observe(ref, 'modalOpen', ({newValue}) => {
            if (newValue) {
                window.addEventListener('keydown', ref.handleKeyDown, true);
                setHasModalChild(true);

                requestAnimationFrame(() => {
                    ref.myRefs[ref.state.focusedRefId] &&
                        ref.myRefs[ref.state.focusedRefId].current &&
                        ref.myRefs[ref.state.focusedRefId].current.focus();
                });
            } else {
                window.removeEventListener('keydown', ref.handleKeyDown, true);
                setHasModalChild(false);
            }
        });
    } catch (err) {
        console.error('An error occured while trying to register modal callback', err);
        sendMonitor('regModalCallbacks Error');
    }
};

export async function renderMessageModal(root) {
    return new Promise(async (resolve, reject) => {
        root.render(
            <ModalMessage
                ref={ref => {
                    if (ref) {
                        regModalCallbacks(observable.box(ref));
                        resolve(ref);
                    }
                }}
            />
        );

        getServerTexts();
    });
}
